<template>
  <div class="mod-rm__siteinfo">
    <!--<el-card shadow="never"-->
             <!--class="aui-card&#45;&#45;fill">-->
    <div class="pkg-search-box">
      <el-form class="pkg-content"
               :inline="false"
               :model="dataForm"
               @submit.native.prevent
               @keyup.enter.native="querySiteInfo()"
               label-width="90px">
        <el-row>
          <!--场地名称-->
          <el-col :span="7">
            <el-form-item :label="$t('res.site.name')">
              <el-input v-model.trim="dataForm.siteCnName"
                        :placeholder="$t('res.vehinfo.input')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!--场地编码-->
          <el-col :span="7">
            <el-form-item :label="$t('res.site.code')">
              <el-input v-model.trim="dataForm.siteNo"
                        :placeholder="$t('res.vehinfo.input')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!--场地分类-->
          <el-col :span="7">
            <el-form-item :label="$t('res.site.classification')">
              <class-tree ref="classRef"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultProps"
                          v-bind:url="queryTreeUrl"
                          v-on:clearTreeInfo="clearSiteTree"
                          v-bind:listName="'siteinfo'"
                          v-bind:isSelect=false
                          v-bind:status="'siteClassStatus'"></class-tree>
            </el-form-item>
          </el-col>
          <!--查询按钮-->
          <el-col :span="3"
                  class="query-button">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         v-if="$hasPermission('AUTHSITEINF0001')"
                         @click="querySiteInfo()">{{ $t('query') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--场地状态-->
        <el-row>
          <el-col :span="7">
            <el-form-item :label="$t('res.site.status')">
              <el-select multiple
                         collapse-tags
                         v-model="dataForm.statusList"
                         :placeholder="$t('res.vehinfo.select')"
                         clearable>
                <el-option v-for="(item,index) in statusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--所在城市-->
          <el-col :span="7"
                  class="padt7">
            <el-form-item :label="$t('res.site.city')">
              <class-tree ref="cityclassRef"
                          v-on:getSelectList="getcitySelectList"
                          v-bind:defaultProps="citydefaultProps"
                          v-bind:isOpen=false
                          v-bind:url="queryCityTreeUrl"
                          v-on:clearTreeInfo="clearCityTree"
                          v-bind:listName="'city'"
                          v-bind:isSelect=false></class-tree>
            </el-form-item>
          </el-col>
          <!--场地标签-->
          <el-col :span="7">
            <el-form-item class="search-item" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                           @click.native.prevent="showSuboLableDlg">{{ $t('res.site.label')}}</el-link>
                </span>
              <div class="el-input el-input--default el-input__inner el-form-item__content" style="height:30px;" @mouseenter="siteLabelShow()" @mouseleave="siteLabelLeave()" >
                <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeName}}</div>
                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="siteLabelShowFlg && dataForm.labelTypeName != '' && dataForm.labelTypeName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="siteLabelName()"></el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="3"
                  class="query-button">
            <el-col :span="24">
              <!--重置-->
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         v-if="$hasPermission('AUTHSITEINF0002')"
                         @click="resetQuery">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <div class="search">
        <!--新增-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHSITEINF0003')"
                   @click="addUpdate()">{{ $t('add') }}</el-button>
        <!--导出-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHSITEINF0004')"
                   @click="exportHandle()">{{ $t('export') }}</el-button>
      </div>
      <el-table :data="dataList"
                border
                stripe
                v-loading="dataListLoading"
                style="width: 100%;">
        <!--序号-->
        <el-table-column prop="xh"
                         fixed
                         :label="$t('res.site.serialNumber')"
                         type="index"
                         :index="indexCreate"
                         width="50"
                         align="center">
        </el-table-column>
        <!--场地编码-->
        <el-table-column prop="siteNo"
                         width="120"
                         align="center"
                         :label="$t('res.site.code')">
        </el-table-column>
        <!--场地名称-->
        <el-table-column prop="siteCnName"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.name')">
        </el-table-column>
        <!--场地简称-->
        <el-table-column prop="siteAbbr"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.shortName')">
        </el-table-column>
        <!--所属分类-->
        <el-table-column prop="siteType"
                         :formatter="siteTypeFormatter"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.type')">
        </el-table-column>
        <!--所属公司-->
        <el-table-column prop="companyCnName"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.company')">
        </el-table-column>
        <!--所在城市-->
        <el-table-column prop="cityName"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.city')">
        </el-table-column>
        <!--场地分类-->
        <el-table-column prop="siteClassCnName"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.classification')">
        </el-table-column>
        <!--场地标签-->
        <el-table-column header-align="center"
                         align="center"
                         :label="$t('res.site.label')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  v-if="scope.row.number !== null"
                  @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
          </template>
        </el-table-column>
        <!--场地状态-->
        <el-table-column :formatter="statusFormatter"
                         prop="status"
                         width="80"
                         align="center"
                         show-overflow-tooltip
                         :label="$t('res.site.status')">
        </el-table-column>
        <!--操作-->
        <el-table-column fixed="right"
                         align="center"
                         width="120"
                         v-if="$hasPermission('AUTHSITEINF0005') || $hasPermission('AUTHSITEINF0006') || $hasPermission('AUTHSITEINF0007') || $hasPermission('AUTHSITEINF0008')"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  v-if="$hasPermission('AUTHSITEINF0005')"
                  @click="gotoView('view', scope.row)">{{ $t('res.vehinfo.check') }}</span>
            <div class="pkg-vertical-divider"></div>
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!--查看-->
                <!--<el-dropdown-item v-if="$hasPermission('AUTHSITEINF0005')" @click.native="gotoView('view', scope.row)">{{ $t('res.vehinfo.check') }}</el-dropdown-item>-->
                <!--编辑-->
                <el-dropdown-item v-if="$hasPermission('AUTHSITEINF0006')" @click.native="gotoView('update', scope.row)">{{ $t('res.edit')}}
                </el-dropdown-item>
                <!--活动-->
                <el-dropdown-item v-if="scope.row.status === '20' && $hasPermission('AUTHSITEINF0007')"
                                  @click.native="gotoView('activity', scope.row)">{{ $t('res.activity')}}</el-dropdown-item>
                <!--不活动-->
                <el-dropdown-item v-if="scope.row.status === '10' && $hasPermission('AUTHSITEINF0008')"
                                  @click.native="gotoView('noActivity', scope.row)">{{ $t('res.noActivity')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
               :visible="isShowLable"
               width="70%"
               :before-close="showLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
               :visible="isQueryShowLable"
               width="70%"
               :before-close="showQueryLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "true"
                     :closeShow = "true"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary"
                   @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddressSelect from '@/components/address-select'
import ClassTree from '@/components/rm/class-tree/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/siteinfo/list',
        getDataListIsPage: true,
        deleteURL: '/rm/siteinfo/delete',
        deleteIsBatch: true,
        exportURL: '/rm/siteinfo/export',
        siteClassesURL: '/rm/siteclass/list'
      },
      dataForm: {
        siteCnName: '',
        siteNo: '',
        label:[],
        labelTypeName: '',
        siteClassList: [],
        statusList: [],
        cityClassList: []
      },
      siteLabelShowFlg: false,
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 8,
      bussinessTypeChecked: 8,
      statusArr: this.enums['status'], // 状态
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      // 场地分类
      defaultProps: {
        children: 'children',
        label: 'siteClassCnName'
      },
      queryTreeUrl: '/rm/siteclass/list',
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree'
    }
  },
  components: {
    Tag,
    AddressSelect,
    'class-tree': ClassTree
  },
  activated () {
    this.getDataList()
  },
  methods: {
    clearSiteTree (listName){
      if(listName === 'siteinfo'){
        this.dataForm.siteClassList = []
      }
    },
    clearCityTree (listName){
      if(listName === 'city'){
        this.dataForm.cityClassList = []
      }
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    onOkLable(){
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let vehicleLabelinfo = []
        let vehicleLabelinfoName = []
        args.forEach(function (item) {
          vehicleLabelinfo.push(item.labelId)
          vehicleLabelinfoName.push(item.labelName)
        })
        this.dataForm.label = vehicleLabelinfo
        this.dataForm.labelTypeName = vehicleLabelinfoName.join(',')
        console.info(this.dataForm.label)
        console.info(this.dataForm.labelTypeName)
      } else {
        this.dataForm.label = []
        this.dataForm.labelTypeName = ''
      }
      this.isQueryShowLable = false
    },
    // 所属分类的转换
    siteTypeFormatter (row) {
      return Vue.filter('coverEnum')(row.siteType, 'orgType')
    },
    // 重置查询条件
    resetQuery () {
      this.reset()
      this.$refs.classRef.resetChecked()
      this.$refs.cityclassRef.resetChecked()
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.$refs.tagTree && this.$refs.tagTree.isReset()
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 操作区下拉选
    gotoView (type, row) {
      let query = {}
      let name = 'rm-siteinfo-add-or-update'
      query.id = row.id
      if (type === 'view') {
        name = 'rm-siteinfo-view'
        query.operationType = 'update'
        query.siteId = row.siteType
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.SITE_INFO, '')
      } else if (type === 'update') {
        query.operationType = 'update'
        query.siteId = row.siteType
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.SITE_INFO, '')
      } else if (type === 'activity') {
        this.modify(type, row)
      } else if (type === 'noActivity') {
        this.modify(type, row)
      }
    },
    // 修改活动/不活动
    modify (type, row) {
      let tips
      if (type === 'activity') {
        tips = this.$t('res.site.siteActivityStatus')
      } else if (type === 'noActivity') {
        tips = this.$t('res.site.siteInactiveStatus')
      }
      this.$confirm(tips, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        row['statusType'] = type
        this.$request.post(
          `/rm/siteinfo/updateStatus`, row
        ).then((data) => {
          this.getDataList()
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              console.log('onClose')
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 新增
    addUpdate (row) {
      let name = 'rm-siteinfo-add-or-update'
      let pkName = (row != null) ? row.id : undefined
      let query = {}
      query.id = pkName
      query.operationType = 'add'
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.SITE_INFO, '')
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 批量导出
    exportHandle () {
      // download 参数 url, params, 报表名
      this.$request.downloadRm('/rm/siteinfo/export', this.$t('res.cri.site.siteInfo'),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit
        }
      )
    },
    getSelectList (args) {
      let siteClass = []
      if(args && args.length > 0){
        args.forEach(function (item) {
          siteClass.push(item.id)
        })
        this.dataForm.siteClassList = siteClass
      }else{
        this.dataForm.siteClassList = []
      }

    },
    getcitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let citySelect = []
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
        this.dataForm.cityClassList = citySelect
      } else {
        this.dataForm.cityClassList = []
      }
    },
    // 生成网格的序号
    indexCreate (index) {
      return (this.page - 1) * this.limit + (index + 1)
    },
    // 主页面查询按钮
    querySiteInfo () {
      this.page = 1
      this.getDataList()
    },
    checkLable(row){
      this.isShowLable = true
      console.info('hgjghj')
      console.info(row)
      console.info(row.id)
      console.info('qwerbcvbcbqwer')
      this.$request.get(`/rm/siteinfo/info/${row.id}`).then((data) => {
        console.info('qwerqwer')
        console.info(data)
        console.info('dfbfdgdg')
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
      })
    },
    showLableClose(){
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 3
      this.bussinessTypeId = 3
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameCn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameEn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
    },
    siteLabelShow () {
      this.siteLabelShowFlg = true
    },
    siteLabelLeave () {
      this.siteLabelShowFlg = false
    },
    siteLabelName () {
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.siteLabelShowFlg = false
      this.$refs.tagTree.isReset()
    }
  }
}
</script>
<style lang="css" scoped>
  @import "../../css/pkg-styles.css";
</style>
